import React from 'react';
import { SponsorsImage, SponsorText, SponsorTitle, SponsorAurora, Section} from './styles';
import SponsorList from '../../assets/Sponsor/sponsors.svg';
import sponsorAuroraImage from '../../assets/Sponsor/sponsorAurora.svg';

const Sponsor: React.FC = () => {
  return (
    <Section id="sponsor">
      <SponsorTitle>DUBHACKS 2024 SPONSORS</SponsorTitle>
      <SponsorAurora src={sponsorAuroraImage} alt="sponsorAurora" />
      <SponsorText>DubHacks is made possible with special thanks to our incredible sponsors
            & their support to champion innovation & creativity for emerging technologists.
      </SponsorText>
      <SponsorsImage src={SponsorList} alt="Sponsors" />
    </Section>
  );
}

export default Sponsor;
